import { usePlayer } from './usePlayer';

export const usePlayerAsset = () => {
  const player = usePlayer();

  return player?.getRawAsset();
};
